export default __webpack_public_path__ + "static/media/041-banana.03271ff0.svg";